import { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { ContractResource } from "@/interfaces";
import RefuseQuoteDialog from "./refuse-quote-dialog";
import { CONTRACT_STATUS_ACTIVE } from "../constants";

interface Props {
  contract?: ContractResource;
  onRefused: () => void;
}

const RefuseQuoteLink: FC<Props> = ({ contract, onRefused }) => {
  const { t } = useTranslation(["quote-refusal"]);
  const [open, setOpen] = useState(false);
  const statusId = Number(contract?.attributes.status_id);
  const isClosed = statusId < 0;
  const isSigned = Boolean(
    contract?.attributes.signature_url ||
    statusId === CONTRACT_STATUS_ACTIVE ||
    (contract?.attributes.is_terms_accepted && contract?.attributes.is_clauses_accepted)
  );

  if (!contract || isClosed || isSigned) {
    return null;
  }

  return (
    <>
      <p className="text-sm text-muted-foreground">
        {t("quote-refusal:refuse-prompt", "Not interested?")}{" "}
        <Button
          className="h-auto cursor-pointer p-0 font-normal text-destructive underline hover:text-destructive/80"
          type="button"
          variant="link"
          onClick={() => setOpen(true)}
        >
          {t("quote-refusal:refuse-link", "Decline this quote")}
        </Button>
      </p>
      <RefuseQuoteDialog contractId={contract.id} open={open} onOpenChange={setOpen} onRefused={onRefused} />
    </>
  );
};

export default RefuseQuoteLink;
